{
  "com_ui_leadhr_action_failed": "That did not work. Please try again.",
  "com_ui_leadhr_active_users": "Active users",
  "com_ui_leadhr_active_users_help": "Active in the last 7 days.",
  "com_ui_leadhr_analytics_subtitle": "How Coco is being adopted across your organisation: who has access, who is using it, and what they are working on.",
  "com_ui_leadhr_analytics_title": "AI Coach",
  "com_ui_leadhr_attention_inactive": "{{n}} users inactive after activating",
  "com_ui_leadhr_attention_inactive_detail": "No conversation in the last 7 days",
  "com_ui_leadhr_attention_none": "Nothing needs your attention right now.",
  "com_ui_leadhr_attention_open": "{{n}} invitations not yet accepted",
  "com_ui_leadhr_attention_open_detail": "{{pct}}% of everyone invited",
  "com_ui_leadhr_attention_subtitle": "Open items across invitations, licences and usage",
  "com_ui_leadhr_attention_title": "Needs your attention",
  "com_ui_leadhr_attention_unassigned": "{{n}} licences unassigned",
  "com_ui_leadhr_attention_unassigned_detail": "Available to invite more people",
  "com_ui_leadhr_attention_view": "View invitations",
  "com_ui_leadhr_avg_messages": "{{count}} messages per conversation on average.",
  "com_ui_leadhr_cancel": "Cancel",
  "com_ui_leadhr_cohort_summary": "{{conversations}} conversations · {{people}} people",
  "com_ui_leadhr_cohort_suppressed": "{{cohort}} is hidden: too few people to report without identifying them.",
  "com_ui_leadhr_col_actions": "Actions",
  "com_ui_leadhr_col_level": "Management level",
  "com_ui_leadhr_col_region": "Region",
  "com_ui_leadhr_col_since": "Since",
  "com_ui_leadhr_col_status": "Status",
  "com_ui_leadhr_col_unit": "Unit",
  "com_ui_leadhr_col_user": "User",
  "com_ui_leadhr_conversations": "Conversations",
  "com_ui_leadhr_engagement_subtitle": "Conversations per week",
  "com_ui_leadhr_engagement_title": "Engagement over time",
  "com_ui_leadhr_eval_applied": "Apply learnings in daily life or work",
  "com_ui_leadhr_eval_clarity": "Gained clarity or a new perspective",
  "com_ui_leadhr_eval_note": "agreed or strongly agreed",
  "com_ui_leadhr_eval_recommend": "Would recommend Coco",
  "com_ui_leadhr_eval_safe": "Feel comfortable & safe",
  "com_ui_leadhr_eval_skills": "Skills people say they are learning",
  "com_ui_leadhr_eval_skills_people": "{{count}} people",
  "com_ui_leadhr_eval_understood": "Feel Coco understands their situation",
  "com_ui_leadhr_eval_useful": "Find conversations useful",
  "com_ui_leadhr_evaluations_basis": "How users rate Coco, based on {{responses}} in-product feedback responses ({{rate}}% response rate).",
  "com_ui_leadhr_evaluations_min_cohort": "Too few people have answered to report this without identifying them.",
  "com_ui_leadhr_evaluations_no_data": "Nobody has answered the evaluation yet.",
  "com_ui_leadhr_evaluations_not_configured": "The in-product evaluation is not switched on for this deployment.",
  "com_ui_leadhr_evaluations_subtitle": "How your people rate Coco, from in-product feedback.",
  "com_ui_leadhr_evaluations_title": "User evaluations",
  "com_ui_leadhr_filter_all": "All",
  "com_ui_leadhr_filter_all_levels": "All levels",
  "com_ui_leadhr_filter_all_regions": "All regions",
  "com_ui_leadhr_filter_level": "Management level",
  "com_ui_leadhr_filter_period": "Time period",
  "com_ui_leadhr_filter_region": "Region",
  "com_ui_leadhr_forgot_back": "Back to login",
  "com_ui_leadhr_forgot_busy": "Sending…",
  "com_ui_leadhr_forgot_intro": "Enter the email you use for bettercoach and we will send you a link to set a new password.",
  "com_ui_leadhr_forgot_sent_intro": "If {{email}} belongs to a bettercoach account, a reset link is on its way.",
  "com_ui_leadhr_forgot_sent_note": "The link expires shortly. If it does not arrive, check your spam folder or try again.",
  "com_ui_leadhr_forgot_sent_title": "Check your email",
  "com_ui_leadhr_forgot_submit": "Send reset link",
  "com_ui_leadhr_forgot_title": "Reset your password",
  "com_ui_leadhr_funnel_activated": "Activated",
  "com_ui_leadhr_funnel_active7d": "Active 7d",
  "com_ui_leadhr_funnel_invited": "Invited",
  "com_ui_leadhr_funnel_signed_up": "Signed up",
  "com_ui_leadhr_funnel_subtitle": "From invitation to active use",
  "com_ui_leadhr_funnel_title": "Activation funnel",
  "com_ui_leadhr_glance_subtitle": "Access and adoption for the selected period.",
  "com_ui_leadhr_glance_title": "At a glance",
  "com_ui_leadhr_guardrail_help": "Added to the platform safety policy for everyone in your company. It can add rules but never weaken the base protections.",
  "com_ui_leadhr_guardrail_title": "Guardrail policy",
  "com_ui_leadhr_guidelines_help": "Guidance injected into every conversation for members of your company.",
  "com_ui_leadhr_guidelines_title": "Company guidelines",
  "com_ui_leadhr_in_use": "{{pct}}% in use",
  "com_ui_leadhr_invitations_accepted": "Invitations accepted",
  "com_ui_leadhr_invitations_note": "{{pct}}% signed up · {{n}} not yet",
  "com_ui_leadhr_invite_email": "Work email",
  "com_ui_leadhr_invite_name": "Name (optional)",
  "com_ui_leadhr_invite_no_limit": "No licence limit has been set for your company.",
  "com_ui_leadhr_invite_seats_left": "{{count}} licence(s) still free.",
  "com_ui_leadhr_invite_send": "Send invitation",
  "com_ui_leadhr_invite_title": "Invite someone to your company",
  "com_ui_leadhr_invite_users": "Invite users",
  "com_ui_leadhr_licences_assigned": "Licences assigned",
  "com_ui_leadhr_licences_open": "{{count}} licences still open",
  "com_ui_leadhr_licences_subtitle": "Everyone invited to Coco: {{used}} of {{total}} licences assigned.",
  "com_ui_leadhr_licences_subtitle_plain": "Everyone invited to Coco.",
  "com_ui_leadhr_licences_subtitle_unlimited": "Everyone invited to Coco: {{used}} licences assigned, no limit set.",
  "com_ui_leadhr_licences_title": "Licences",
  "com_ui_leadhr_loading": "Loading…",
  "com_ui_leadhr_login_busy": "Signing in…",
  "com_ui_leadhr_login_email": "Email",
  "com_ui_leadhr_login_email_placeholder": "Email Address",
  "com_ui_leadhr_login_forgot": "Did you forget your password?",
  "com_ui_leadhr_login_generic_error": "Sign-in failed. Please try again.",
  "com_ui_leadhr_login_hide_password": "Hide password",
  "com_ui_leadhr_login_password": "Password",
  "com_ui_leadhr_login_show_password": "Show password",
  "com_ui_leadhr_login_submit": "Login",
  "com_ui_leadhr_login_title": "Log in to your bettercoach account",
  "com_ui_leadhr_look_subtitle": "Where people drop off between invitation and regular use, and what needs a decision from you.",
  "com_ui_leadhr_look_title": "Where to look",
  "com_ui_leadhr_manage_licences": "Manage licences",
  "com_ui_leadhr_message_crisis": "Suicide and self-harm",
  "com_ui_leadhr_message_general": "Any other declined message",
  "com_ui_leadhr_message_hate_experienced": "Experiencing hate or racism",
  "com_ui_leadhr_message_hate_expressed": "Expressing hate or racism",
  "com_ui_leadhr_message_politics": "Elections and politics",
  "com_ui_leadhr_message_religion": "Religion",
  "com_ui_leadhr_message_sexual": "Sexual content",
  "com_ui_leadhr_message_substances": "Drugs and alcohol",
  "com_ui_leadhr_messages_help": "What your people see when the guardrail declines a message. Leave a field empty to keep the default shown in it. If you reword the suicide and self-harm message, keep emergency contacts in it.",
  "com_ui_leadhr_messages_title": "Guardrail messages",
  "com_ui_leadhr_nav_analytics": "Analytics",
  "com_ui_leadhr_nav_settings": "Company settings",
  "com_ui_leadhr_nav_users": "Licences",
  "com_ui_leadhr_next_page": "Next page",
  "com_ui_leadhr_no_companies": "You do not manage any companies yet.",
  "com_ui_leadhr_no_engagement": "No conversations in this period yet.",
  "com_ui_leadhr_no_limit_help": "No licence limit has been set for your company.",
  "com_ui_leadhr_no_users": "Nobody matches these filters yet.",
  "com_ui_leadhr_period_12w": "Last 12 weeks",
  "com_ui_leadhr_period_26w": "Last 26 weeks",
  "com_ui_leadhr_period_4w": "Last 4 weeks",
  "com_ui_leadhr_prev_page": "Previous page",
  "com_ui_leadhr_question_suppressed": "Too few answers to report.",
  "com_ui_leadhr_remove": "Remove",
  "com_ui_leadhr_reset_busy": "Saving…",
  "com_ui_leadhr_reset_confirm": "Confirm new password",
  "com_ui_leadhr_reset_done_cta": "Go to login",
  "com_ui_leadhr_reset_done_intro": "You can now sign in with your new password.",
  "com_ui_leadhr_reset_done_title": "Password updated",
  "com_ui_leadhr_reset_hint": "At least {{count}} characters.",
  "com_ui_leadhr_reset_intro": "Pick something you have not used before.",
  "com_ui_leadhr_reset_mismatch": "Those two passwords do not match.",
  "com_ui_leadhr_reset_new": "New password",
  "com_ui_leadhr_reset_submit": "Set new password",
  "com_ui_leadhr_reset_title": "Choose a new password",
  "com_ui_leadhr_reset_too_short": "Use at least {{count}} characters.",
  "com_ui_leadhr_revoke": "Revoke",
  "com_ui_leadhr_role": "Lead HR",
  "com_ui_leadhr_save": "Save",
  "com_ui_leadhr_save_failed": "Could not save. Please try again.",
  "com_ui_leadhr_saved": "Saved.",
  "com_ui_leadhr_saving": "Saving…",
  "com_ui_leadhr_search_users": "Search users",
  "com_ui_leadhr_select_company": "Company",
  "com_ui_leadhr_settings_subtitle": "Policy, guidance and the options your people choose from.",
  "com_ui_leadhr_settings_title": "Company settings",
  "com_ui_leadhr_showing": "Showing {{shown}} of {{total}} people",
  "com_ui_leadhr_sign_out": "Log out",
  "com_ui_leadhr_status_active": "Active",
  "com_ui_leadhr_status_invited": "Invited",
  "com_ui_leadhr_status_signed_up": "Signed up",
  "com_ui_leadhr_title": "COCO – AI Coach",
  "com_ui_leadhr_topics_coverage": "Based on {{pct}}% of this period's conversations.",
  "com_ui_leadhr_topics_min_cohort": "Your company is too small to report topics without identifying individuals.",
  "com_ui_leadhr_topics_no_data": "No conversations have been categorised yet. This fills in over the next few visits.",
  "com_ui_leadhr_topics_not_configured": "Nobody has set their region or management level yet, so there is nothing to group by.",
  "com_ui_leadhr_topics_subtitle": "Most-discussed themes, reported only for groups large enough to stay anonymous.",
  "com_ui_leadhr_topics_title": "Prevailing topics",
  "com_ui_leadhr_usage_subtitle": "How often people talk to Coco, and what they bring to it.",
  "com_ui_leadhr_usage_title": "Usage",
  "com_ui_leadhr_users_subtitle": "Licence holders and open invitations, with level, region and activation status.",
  "com_ui_leadhr_users_title": "Users",
  "com_ui_leadhr_vocabulary_help": "Values your people can pick from in their own settings. Reporting groups by these, so keep the list short and stable.",
  "com_ui_leadhr_vocabulary_placeholder": "Add an option and press Enter",
  "com_ui_leadhr_vocabulary_remove": "Remove option",
  "com_ui_leadhr_vocabulary_title": "Profile options",
  "com_ui_leadhr_vs_previous": "Change vs. previous period"
}
